exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loadingContainer---CbhAk {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  position: fixed;\n  left: 0;\n  top: 0;\n  display: flex;\n  background: #dbe3e9;\n  z-index: 100000;\n  opacity: 0.3;\n  height: 100%;\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"loadingContainer": "loadingContainer---CbhAk"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/with-loader/index.scss
// module id = 764
// module chunks = 3